const GAP = 6;
const MARGIN = 8;

export function visibleViewport() {
  const bar = document.querySelector(".sticky-top-bar");
  const top = bar ? Math.max(0, bar.getBoundingClientRect().bottom) : 0;
  return { top, bottom: window.innerHeight, left: 0, right: document.documentElement.clientWidth };
}

function verticalAnchor(anchor, point, first, last) {
  if (point && anchor.bottom - anchor.top > last - first) return { top: point.y, bottom: point.y };
  return { top: Math.max(anchor.top, first), bottom: Math.min(anchor.bottom, last) };
}

export function placePopover({ anchor, container, viewport, width, height, point = null }) {
  const first = viewport.top + MARGIN;
  const last = viewport.bottom - MARGIN;
  const spot = verticalAnchor(anchor, point, first, last);
  const roomBelow = last - (spot.bottom + GAP);
  const roomAbove = spot.top - GAP - first;
  const above = height > roomBelow && roomAbove > roomBelow;
  const wanted = above ? spot.top - GAP - height : spot.bottom + GAP;
  const top = Math.min(Math.max(wanted, first), Math.max(first, last - height));
  const minLeft = viewport.left === undefined ? container.left : Math.max(container.left, viewport.left + MARGIN);
  const maxRight = viewport.right === undefined ? container.right : Math.min(container.right, viewport.right - MARGIN);
  const left = Math.min(Math.max(anchor.left, minLeft), Math.max(minLeft, maxRight - width));
  return { left: left - container.left, top: top - container.top, side: above ? "above" : "below" };
}
